import React from 'react'
import { Helmet } from 'react-helmet-async'
import { UrlEndpointFunctionLayout } from '../../layouts/Settings'

const UrlEndpointFunctionPage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>URL Endpoint Functions</title>
      <meta name="description" content="URL Endpoint Functions page" />
    </Helmet>
    <UrlEndpointFunctionLayout />
  </React.Fragment>
)

export default UrlEndpointFunctionPage